// @flow
import React, { useEffect, useState, memo } from "react";
import { HeaderDiv, BalanceContainer, Balance } from "./HeaderStyled";

import { ReactComponent as SettingsSvg } from "../../../assets/menu.svg";
// import { ReactComponent as UsdSVG } from "./usd.svg";
import currencies from "../../../lib/currencies/currencies";

import useSound from "use-sound";

import forwardSound from "../../../audio/goForward.mp3";

export default memo(function Header({
  betInfo: { balance, winAmount },
  isFast,
  currency,
  handleAbove,
  toFix,
  userSettings: { sound, volume },
}) {
  const [forwardSfx] = useSound(forwardSound, { volume });

  const [balanceH, setbalanceH] = useState(balance);
  const [isFirst, setisFirst] = useState(true);

  useEffect(() => {
    const beforeBalance = (balance - winAmount).toFixed(toFix)
    setbalanceH(beforeBalance)
    if (isFirst && balance) {
      setisFirst(false);
      setbalanceH(balance && balance.toFixed(toFix));
    }
    if (!isFirst) {
      setTimeout( () => {
          setbalanceH(balance && balance.toFixed(toFix));
        },isFast ? 780 : 3500,);
    }
    if (balance === 0) setbalanceH("0.00");
  }, [balance, winAmount, toFix, isFirst, isFast]);

  return (
    <HeaderDiv>
      <p>SPHERES</p>
       <BalanceContainer>
       <span>
        {currencies[currency]}
      </span>
      <Balance>{balanceH}</Balance>
       </BalanceContainer>
    
      <SettingsSvg
        onClick={() => {
          if (sound) forwardSfx();
          handleAbove("settings");
        }}
      />
    </HeaderDiv>
  );
});
